import React from 'react';
import './label.scss';

export default function Label(props) {
  const {children, label, style} = props;
  return (
    <div className="label" style={style}>{children || label}</div>
  );
}
